/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import UserInfo from '@/components/UserInfo/index.vue';
import {ContributorInterface} from '@/store/modules/issues/types';

@Component({
    name: 'c-user-description',
    components: {
        'c-user-info': UserInfo,
    },
})
export default class UserDescription extends Vue {
    @Prop() private content!: ContributorInterface;
    private more: boolean = false;

    /**
     * Show/hide additional details.
     * @param {boolean} show
     */
    public showMore(show: boolean): void {
        this.more = show;
    }

    /**
     * Show Image in new tab
     */
    public showImage(path: string): void {
        window.open(path, '_blank');
    }
}
